module.exports = __webpack_public_path__ + "img/loading-circle.6d1729a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/loading-circle.svg
// module id = ./assets/img/loading-circle.svg
// module chunks = 0 1 4 5 6